export enum CREWHUB_ROUTES {
  EMPTY = '/',
  SEATMAP = '/page/seat-map',
  FLIGHT_DETAILS = '/page/flight-details',
  GUEST_LIST = '/page/guest-list',
  SCHEDULE = '/page/schedule',
  SSR_DETAILS = '/page/ssr-details',
  LOGIN = '/page/login',
  FLIGHTS = '/page/flights'
}
